import { Component, OnInit, Input } from '@angular/core';
import { environment } from '@env/environment';
import { Attachment } from '@shared/models/help-ticket.model';

@Component({
  selector: 'miq-attachment',
  template: `
    <miq-secured-download-link [path]="attachmentLink" target="_blank" [fileName]="attachment.name">
      <span content>{{ attachment.name }}</span>
      <span failure>{{ attachment.name }}</span>
    </miq-secured-download-link>
  `,
  standalone: false,
})
export class AttachmentComponent implements OnInit {
  @Input() attachment: Attachment;
  s3BucketTicketUrl = environment.s3BucketTicketsUrl;
  attachmentLink: string;

  ngOnInit() {
    const linkArray = this.attachment.link.split('/');
    const fileName = `${linkArray[1]}/${linkArray[2]}`;
    this.attachmentLink = `${this.s3BucketTicketUrl}${fileName}`;
  }
}
